<div mat-dialog-content>
    {{message}}
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Abbrechen</button>
    <button mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
  </div>